<script setup lang="ts">
import { sub } from "date-fns";
import type { Period, Range } from "~/types";

const { isNotificationsSlideoverOpen, isGarnmentSlideoverOpen } =
  useDashboard();

const items = [
  [
    {
      label: "New mail",
      icon: "i-heroicons-paper-airplane",
      to: "/inbox",
    },
    {
      label: "New user",
      icon: "i-heroicons-user-plus",
      to: "/users",
    },
  ],
];

const range = ref<Range>({
  start: sub(new Date(), { days: 14 }),
  end: new Date(),
});
const period = ref<Period>("daily");
</script>

<template>
  <UDashboardPage>
    <UDashboardPanel grow>
      <UDashboardNavbar title="Gallery">
        <template #right>
          <UButton
            color="gray"
            variant="ghost"
            square
            @click="isGarnmentSlideoverOpen = true"
          >
            <UIcon dynamic name="i-hugeicons-hanger" class="w-5 h-5" />
          </UButton>
          <div class="w-[200px]">
            <UserDropdown2 />
          </div>
        </template>
      </UDashboardNavbar>

      <UDashboardPanelContent>
        <!-- ~/components/home/HomeChart.vue -->
        <ImageGallery />
      </UDashboardPanelContent>
    </UDashboardPanel>
  </UDashboardPage>
</template>
